import { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useOnboarding, useQuestionnaire } from "../../hooks";
import { Onboarding as OnboardingComponent } from "../../components";
import type { OnboardingData } from "../../types";

const OnboardingPage = observer(function OnboardingPage() {
  const navigate = useNavigate();
  const { complete } = useOnboarding();
  const { submitOnboardingQuestionnaire } = useQuestionnaire();

  const handleComplete = useCallback(
    async (data: OnboardingData) => {
      complete(data);
      await submitOnboardingQuestionnaire(data);
      navigate("/dashboard");
    },
    [complete, navigate, submitOnboardingQuestionnaire],
  );

  return <OnboardingComponent onComplete={handleComplete} />;
});

export default OnboardingPage;